import { OwnerScope } from '@vivport/backend/types';
import { httpClient } from './http-client';

export interface Work4MeAgentDetail {
  id: number;
  ownerScope: OwnerScope;
  name: string;
  description: string | null;
  instructions: string;
  skillIds: number[];
  isEnabled: boolean;
  updatedAt: string;
}

export interface UpdateWork4MeAgentInput {
  name?: string;
  description?: string | null;
  instructions?: string;
  skillIds?: number[];
  isEnabled?: boolean;
}

export interface CreateWork4MeAgentInput {
  ownerType?: 'HUB' | 'MEMBER';
  name: string;
  description?: string | null;
  instructions: string;
  skillIds?: number[];
  isEnabled?: boolean;
}

export async function getWork4MeAgent(id: number): Promise<Work4MeAgentDetail> {
  return httpClient.get<Work4MeAgentDetail>(`/protected/agents/${id}`);
}

export async function createWork4MeAgent(input: CreateWork4MeAgentInput): Promise<Work4MeAgentDetail> {
  return httpClient.post<Work4MeAgentDetail, CreateWork4MeAgentInput>('/protected/agents', input);
}

export async function updateWork4MeAgent(
  id: number,
  input: UpdateWork4MeAgentInput
): Promise<Work4MeAgentDetail> {
  return httpClient.patch<Work4MeAgentDetail, UpdateWork4MeAgentInput>(`/protected/agents/${id}`, input);
}

export async function deleteWork4MeAgent(id: number): Promise<void> {
  return httpClient.delete<void>(`/protected/agents/${id}`);
}
